/* eslint-disable max-len */
import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import FlexBox, { FlexGrow } from "./FlexBox";
import { StyledText, TextSize } from "./Text";
import { LocationInterface } from "./UtilsComponents";
import CompetencyNavbar from "./CompetencyNavbar";
import CompetencyAddModal from "./CompetencyAddModal";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import LoadingSpinner from "./LoadingSpinner";
import Icon from "@mui/material/Icon";
import { UserContext } from "../context/UserContext";
import { SemesterContext } from "../context/SemesterContext";
import defaultImg from "../assets/DefaultCardImage.png";
import { CompetencyType } from "../types/Milestone";
import WarningModal from "./WarningModal";
import { computeHeadingLevel } from "@testing-library/react";
import SnackBar from "./SnackBar";
import CompetencyAddModalNew from "./CompetencyAddModalNew";
import { PrerequisiteChainModal } from "./prerequisiteChainModal";
import { ReactFlowProvider } from "@xyflow/react";
import { handleJWTError } from "../hooks/jwtErrHandler";
import { UniversityContext } from "../context/UniversityContext";
import { hasNoCurriculumVersionsForExplore } from "../utils/exploreCompetency";
import ExploreNoVersionState from "./ExploreNoVersionState";

type BlockProps = {
  backgroundColor: string;
};
export const StyledImg = styled.img`
  width: 100%;
  height: 60%;
  max-height: 60%;
  min-height: 60%;
  margin-bottom: 10px;
  border-radius: 7px;
`;
const StyledLines = styled.hr<{
  degree: string;
  left: string;
  top: string;
  height: string;
}>`
  transform: rotate(${({ degree }) => degree});
  position: absolute;
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  height: ${({ height }) => height};
  z-index: 1;
  border: 0.5px solid #545454;
`;
export const CustomAssessmentBlock = styled(FlexGrow) <BlockProps>`
  margin-bottom: 0;
  text-align: center;
  border-radius: 12px;
  // border-radius: 12px;
  background: ${({ backgroundColor }) => backgroundColor};
  box-shadow: rgb(101 101 101) 0px 1px 4px 0px;
  padding: 0px 16px 16px 16px;
  flex-grow: 0;
  position: relative;
  cursor: pointer;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  height: 350px;
  min-height: 350px;
  max-height: 350px;
  overflow: hidden;
//   :after {
//     z-index: 1px;
//     border-bottom: 40px solid transparent;
//     border-left: 20px solid transparent;
//     // border-right: 20px solid;
//     // border-image-source: ${({ backgroundColor }) => backgroundColor};
//     border-color: ${({ backgroundColor }) => backgroundColor};
//     content: '';
//     height: 0;
//     position: absolute;
//     top: 3px;
//     width: 0;
//     right: 14px;
//     transform: rotate(315deg);
// }
  }
  // :before {
  //   z-index: 1px;
  //   border-bottom: 40px solid transparent;
  //   // border-left: 20px solid;
  //   // border-image-source: ${({ backgroundColor }) => backgroundColor};
  //   border-color: ${({ backgroundColor }) => backgroundColor};
  //   border-right: 20px solid transparent;
  //   content: '';
  //   height: 0;
  //   position: absolute;
  //   top: 3px;
  //   width: 0;
  //   left: 14px;
  //   transform: rotate(45deg);
  // }
`;
export const CustomBlock = styled(FlexGrow) <BlockProps>`
  margin-bottom: 16px;
  text-align: center;
  background: ${({ backgroundColor }) => backgroundColor};
  padding: 0px 16px 16px 16px;
  flex-grow: 0;
  position: relative;
  cursor: pointer;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  height: 350px;
  min-height: 350px;
  max-height: 350px;
  overflow: hidden;
  border-radius: 12px;
  //   :after {
  //     z-index: 1px;
  //     border-bottom: 40px solid transparent;
  //     border-left: 20px solid transparent;
  //     // border-right: 20px solid;
  //     // border-image-source: ${({ backgroundColor }) => backgroundColor};
  //     border-color: ${({ backgroundColor }) => backgroundColor};
  //     content: '';
  //     height: 0;
  //     position: absolute;
  //     top: 3px;
  //     width: 0;
  //     right: 14px;
  //     transform: rotate(315deg);
  // }
  //   }
  //   :before {
  //     z-index: 1px;
  //     border-bottom: 40px solid transparent;
  //     // border-left: 20px solid;
  //     // border-image-source: ${({ backgroundColor }) => backgroundColor};
  //     border-color: ${({ backgroundColor }) => backgroundColor};
  //     border-right: 20px solid transparent;
  //     content: '';
  //     height: 0;
  //     position: absolute;
  //     top: 3px;
  //     width: 0;
  //     left: 14px;
  //     transform: rotate(45deg);
  //   }
`;
const hashLines = [
  { degree: "45deg", left: "0", top: "-12px", height: "20px" },
  { degree: "45deg", left: "14px", top: "-22px", height: "60px" },
  { degree: "45deg", left: "28px", top: "-32px", height: "100px" },
  { degree: "45deg", left: "42px", top: "-42px", height: "140px" },
  { degree: "45deg", left: "56px", top: "-52px", height: "180px" },
  { degree: "45deg", left: "70px", top: "-62px", height: "220px" },
  { degree: "45deg", left: "84px", top: "-72px", height: "260px" },
  { degree: "45deg", left: "98px", top: "-82px", height: "300px" },
  { degree: "45deg", left: "112px", top: "-92px", height: "340px" },
  { degree: "45deg", left: "100px", top: "-27px", height: "285px" },
  { degree: "45deg", left: "100px", top: "0px", height: "285px" },
  { degree: "45deg", left: "100px", top: "27px", height: "285px" },
  { degree: "45deg", left: "100px", top: "54px", height: "285px" },
  { degree: "45deg", left: "100px", top: "81px", height: "285px" },
  { degree: "45deg", left: "100px", top: "108px", height: "285px" },
  { degree: "45deg", left: "100px", top: "135px", height: "285px" },
  { degree: "45deg", left: "100px", top: "162px", height: "285px" },
  { degree: "45deg", left: "100px", top: "189px", height: "285px" },
  { degree: "45deg", left: "100px", top: "216px", height: "285px" },
  { degree: "45deg", left: "100px", top: "243px", height: "285px" },
];
function CompetenciesList(props: { warningMessage: string }) {
  let location = useLocation() as LocationInterface;
  const { node, id, parent, child } = location?.state || {};
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCompetency, setSelectedCompetency] = useState<any>({});
  const [competencies, setCompetencies] = useState<Array<{}>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [breadcrumbData, setBreadcrumbData] = useState<any>([]);
  const semesterContext = useContext(SemesterContext);
  const { user, setSearchView } = useContext(UserContext);
  const [stuSelectedVersion, setStuSelectedVersion] = useState<Number>(0);
  const [warningMessage, setWarningMessage] = useState<any>(null);
  const [warningOpen, setWarningOpen] = useState<boolean>(false);
  const [studentCompetencies, setStudentCompetencies] = useState<any>([]);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [activeVersion, setActiveVersion] = useState<Number>(0);
  const [searchValue, setSearchValue] = useState<string>("");

  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");

  const [chainModalOpen, setChainModalOpen] = useState<boolean>(false);

  const navigate = useNavigate();
  if (!node) {
    navigate("/explore");
  }
  useEffect(() => {
    fetchCompetency(id);
  }, [node, id, location, semesterContext]);
  useEffect(() => {
    updateBreadcrumb(parent, child);
  }, [parent, child, props.warningMessage]);
  useEffect(() => {
    fetchCompetency(id);
    initialRole.role === 1 && fetchStudentCompetencies();
  }, [node, id, location, semesterContext]);

  useEffect(() => {
    searchValue && searchCompetencies(searchValue);
  }, [semesterContext.selectedSemester, semesterContext.selectedSemesterVersion]);

  const universityContext: any = useContext(UniversityContext);
  const storedRole = localStorage.getItem("role");
  const initialRole = JSON.parse(storedRole as string);
  const fetchCompetency = (idString: string) => {
    if (
      hasNoCurriculumVersionsForExplore(
        user.role,
        semesterContext.selectedSemester,
        semesterContext.semesterVersions,
        semesterContext.semesterVersionsLoading
      )
    ) {
      setLoading(false);
      setCompetencies([]);
      return;
    }

    if (user.role !== 1 && semesterContext.semesterVersionsLoading) {
      setLoading(true);
      return;
    }

    setLoading(true);
    if (
      semesterContext.selectedSemester?.label &&
      semesterContext.selectedSemester?.label === "All" &&
      user.role === 1
    ) {
      axios
        .get(
          `/competency?subdomain_id=${idString}&university_code=${user.university_code || "CMKL"
          }`
        )
        .then((res) => {
          if (res.data.competencies) {
            !searchValue && setCompetencies(res.data.competencies);
            // if (semesterContext.selectedSemester?.label === "All") {
            //   setCompetencies(res.data.competencies);
            // } else {
            //   setCompetencies(res.data.competencies);
            // filterCompetencies(res.data.competencies);
            // }
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else if (
      user.role !== 1 ||
      semesterContext.selectedSemester?.label === "All"
    ) {
      axios
        .get(`/version?university_code=CMKL`)
        .then((res) => {
          const version_number = res.data.versions.find(
            (v: any) => v.status === "Active Prime"
          ).version_number;
          setActiveVersion(version_number);
          var url = `/competency?subdomain_id=${idString}&university_code=${user.university_code || "CMKL"
            }&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ||
              semesterContext.selectedSemester?.label !== "All"
              ? version_number
              : semesterContext.selectedSemesterVersion
            }`;

          if (semesterContext.selectedSemester?.label !== "All") {
            url = `/competency?subdomain_id=${idString}&university_code=${user.university_code || "CMKL"
              }&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ? version_number : semesterContext.selectedSemesterVersion
              }&semester_name=${semesterContext.selectedSemester?.label}`;
          }
          axios
            .get(url)
            .then((res) => {
              if (res.data.competencies) {
                if (semesterContext.selectedSemester?.label === "All") {
                  setCompetencies(res.data.competencies);
                } else {
                  setCompetencies(res.data.competencies);
                  // filterCompetencies(res.data.competencies);
                }
              }
              setLoading(false);
            })
            .catch(() => {
              setCompetencies([]);
              setLoading(false);
              navigate("/explore");
            });
        })
        .catch(() => { });
    } else {
      semesterContext.selectedSemester?.label &&
        axios
          .get(
            `/student/version?student_id=${initialRole.role_id}&semester_name=${semesterContext.selectedSemester?.label}&program_id=${user.programs[0].id}`
          )
          .then((res) => {
            setStuSelectedVersion(res.data.version.curriculum_version);
            axios
              .get(
                `/competency?subdomain_id=${idString}&university_code=${user.university_code || "CMKL"
                }&curriculum_version=${res.data.version.curriculum_version
                }&semester_name=${semesterContext.selectedSemester?.label}`
              )
              .then((res) => {
                if (res.data.competencies) {
                  filterCompetencies(res.data.competencies);
                }
                setLoading(false);
              })
              .catch(() => { });
          })
          .catch((err) => { });
    }
  };
  const filterCompetencies = async (competenciesArr: Array<{}>) => {
    try {
      let filteredData: Array<{}> = [];
      const studentCompetencies = await fetchStudentCompetencies();

      competenciesArr.forEach((comp: any) => {
        if (
          comp.semester_detail &&
          comp.semester_detail.semester_name !== "" &&
          comp.available
        ) {
          filteredData.push(comp);
        }
      });
      //include true to all the competencies that match
      const result1 = competenciesArr.map((item: any) => {
        const shouldInclude = studentCompetencies.includes(
          item.competency_code
        );

        return {
          ...item,
          ...(shouldInclude && { included: true }),
        };
      });

      setCompetencies(result1);
    } catch (error) {
      console.error("Error filtering competencies:", error);
    }
  };

  //get student competencies for roadmap
  const fetchStudentCompetencies = async () => {
    try {
      const res = await axios.get(
        `/roadmap/milestones?student_id=${initialRole.role_id}&year=${semesterContext.selectedSemester?.year}&semester=${semesterContext.selectedSemester?.label}&program_name=${user?.programs?.[0]?.program_name || universityContext.selectedProgram?.short_name}`
      );
      if (
        res.data &&
        res.data.roadmaps &&
        res.data.roadmaps[0] &&
        res.data.roadmaps[0].milestones
      ) {
        const tempArr: any = [];
        res.data.roadmaps[0].milestones.forEach((v: any) => {
          tempArr.push(v.competency_card?.competency_code);
        });
        setStudentCompetencies(tempArr);

        return tempArr;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching student competencies:", error);
      handleJWTError(error);
      return [];
    }
  };

  const updateBreadcrumb = (parentData: any, childData: any) => {
    setBreadcrumbData([
      { link: "/explore/child", name: parentData?.label, ...parentData },
      {
        link: "/explore/child/competencies",
        name: childData?.label,
        ...childData,
      },
    ]);
  };
  const searchCompetencies = (searchVal: string) => {
    setLoading(true);
    setSearchValue(searchVal);
    setSearchView(true);

    if (searchVal && searchVal !== "") {
      let axiosStr = "/competency/summary?university_code=CMKL";
      if (user.role !== 1 || semesterContext.selectedSemester?.label === "All") {
        axios
          .get(`/version?university_code=CMKL`)
          .then((res) => {
            const version_number = res.data.versions.find(
              (v: any) => v.status === "Active Prime"
            ).version_number;
            setActiveVersion(version_number);

            axiosStr =
              semesterContext.selectedSemester?.label === "All"
                ? semesterContext.selectedSemester?.label &&
                `/competency/summary?university_code=CMKL&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ? version_number : semesterContext.selectedSemesterVersion
                }`
                : semesterContext.selectedSemester?.label &&
                `/competency/summary?university_code=CMKL&curriculum_version=${semesterContext.selectedSemesterVersion === 0 ? version_number : semesterContext.selectedSemesterVersion
                }&semester_name=${semesterContext.selectedSemester?.label}`;
            axios
              .get(axiosStr)
              .then((res) => {
                if (res.data.competencies) {
                  if (
                    res.data.competencies &&
                    res.data.competencies.length > 0
                  ) {
                    let searchArray = searchVal.trim().split(" ");
                    let re = new RegExp(searchArray.join("|"), "i");
                    // let resultsObj = res.data.competencies.filter(
                    //   (competencyItem: CompetencyType) =>
                    //     re.test(competencyItem.competency_code) ||
                    //     re.test(competencyItem.title)
                    // );
                    let resultsObj =
                      searchVal.trimStart() !== ""
                        ? res.data.competencies.filter(
                          (competencyItem: CompetencyType) =>
                            competencyItem.competency_code
                              .toLowerCase()
                              .includes(searchVal.toLowerCase()) ||
                            competencyItem.title
                              .toLowerCase()
                              .includes(searchVal.toLowerCase())
                        )
                        : [];
                    filterCompetencies(resultsObj);
                  } else {
                    fetchCompetency(id);
                  }
                }
                setLoading(false);
              })
              .catch(() => {
                fetchCompetency(id);
                setLoading(false);
              });
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        axiosStr = `/competency/summary?university_code=CMKL&curriculum_version=${stuSelectedVersion}&semester_name=${semesterContext.selectedSemester?.label}`;
        axios
          .get(axiosStr)
          .then((res) => {
            if (res.data.competencies) {
              if (res.data.competencies && res.data.competencies.length > 0) {
                let searchArray = searchVal.trim().split(" ");
                let re = new RegExp(searchArray.join("|"), "i");
                // let resultsObj = res.data.competencies.filter(
                //   (competencyItem: CompetencyType) =>
                //     re.test(competencyItem.competency_code) ||
                //     re.test(competencyItem.title)
                // );
                let resultsObj =
                  searchVal.trimStart() !== ""
                    ? res.data.competencies.filter(
                      (competencyItem: CompetencyType) =>
                        competencyItem.competency_code
                          .toLowerCase()
                          .includes(searchVal.toLowerCase()) ||
                        competencyItem.title
                          .toLowerCase()
                          .includes(searchVal.toLowerCase())
                    )
                    : [];
                filterCompetencies(resultsObj);
                setLoading(false);
              } else {
                fetchCompetency(id);
                setLoading(false);
              }
            }
          })
          .catch(() => {
            fetchCompetency(id);
            setLoading(false);
          });
      }
    } else {
      fetchCompetency(id);
      setLoading(false);
    }
  };

  const [onHover, setHover] = useState<any>(null);

  if (
    user.role !== 1 &&
    semesterContext.semesterVersionsLoading &&
    semesterContext.selectedSemester?.label &&
    semesterContext.selectedSemester.label !== "All"
  ) {
    return <LoadingSpinner />;
  }

  if (
    hasNoCurriculumVersionsForExplore(
      user.role,
      semesterContext.selectedSemester,
      semesterContext.semesterVersions,
      semesterContext.semesterVersionsLoading
    )
  ) {
    return (
      <ExploreNoVersionState
        programLabel={
          universityContext.selectedProgram?.label ||
          universityContext.selectedProgram?.short_name
        }
        semesterLabel={semesterContext.selectedSemester?.label}
      />
    );
  }

  return (
    <>
      {warningMessage && (
        <WarningModal
          setOpen={setWarningOpen}
          isOpen={warningOpen}
          title="Warning"
          description={warningMessage}
        />
      )}
      { }
      {isModalOpen && (
        <CompetencyAddModalNew
          isWarningOpen={warningOpen}
          setIsWarningOpen={setWarningOpen}
          fetchCompetency={() =>
            searchValue ? searchCompetencies(searchValue) : fetchCompetency(id)
          }
          message={message}
          setMessage={setMessage}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          setWarningMessage={setWarningMessage}
          setWarningOpen={setWarningOpen}
          isStudent={user.role === 1}
          isAddModalOpen={isModalOpen}
          setAddModalOpen={setIsModalOpen}
          data={selectedCompetency}
          onAddComplete={() => { }}
          onAddError={() => { }}
        />
      )}
      {selectedCompetency?.id && (
        <ReactFlowProvider>
          <PrerequisiteChainModal
            setSelectedCompetency={setSelectedCompetency}
            isPrerequisiteModalOpen={chainModalOpen}
            setIsPrerequisiteModalOpen={setChainModalOpen}
            focusCompetency={selectedCompetency?.competency_code}
            focusId={selectedCompetency?.id}
            selectedVersion={semesterContext.selectedSemesterVersion || activeVersion}
            role={initialRole}
          />
        </ReactFlowProvider>
      )}
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
        link
      />
      {isErrorOpen && (
        <SnackBar
          isOpen={isErrorOpen}
          setOpen={setIsErrorOpen}
          header="INFO!"
          message="This competency has been added already"
          type="info"
        />
      )}

      <CompetencyNavbar
        breadcrumb={breadcrumbData}
        searchCompetency={searchCompetencies}
        clearSearch={() => {
          fetchCompetency(id);
          setSearchValue("");
        }}
      />
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <FlexBox
            space={1}
            alignItems="flex-start"
            style={{
              marginRight: "-16px",
              minHeight: "60vh",
            }}
          >
            {competencies.length > 0 ? (
              competencies.map((competency: any) => (
                <>
                  {competency.semester_detail &&
                    competency.semester_detail.assessment_only === true ? (
                    <>
                      <FlexBox
                        direction="column"
                        space={0}
                        style={{
                          marginBottom: "13px",
                          opacity: competency.included ? "0.5" : "1",
                        }}
                      >
                        <FlexGrow style={{ marginBottom: "-8px" }}>
                          <CustomAssessmentBlock
                            backgroundColor={competency.graphics?.iconbg}
                            onClick={() => {
                              if (!competency.included) {
                                setSelectedCompetency(competency);
                                setIsModalOpen(true);
                              } else {
                                setIsErrorOpen(true);
                                setIsErrorOpen(true);
                              }
                            }}
                          >
                            {" "}
                            <div
                              style={{ padding: "5px 0px", fontWeight: "bold" }}
                            >
                              {competency.competency_code}
                            </div>
                            <StyledImg
                              src={
                                competency.graphics?.imgurl
                                  ? process.env.REACT_APP_IMG_URL +
                                  competency.graphics?.imgurl
                                  : defaultImg
                              }
                              alt=""
                            />
                            <Icon
                              sx={{
                                color: "white",
                                padding: "6px",
                                background: competency.graphics?.iconbg,
                                borderRadius: "100px",
                                fontSize: "27px",
                                position: "absolute",
                                left: "50%",
                                bottom: "105px",
                                transform: "translateX(-50%)",
                                boxShadow: competency.graphics?.iconshadow,
                              }}
                            >
                              {competency.graphics?.icon}
                            </Icon>
                            <StyledText
                              fontWeight="700"
                              style={{
                                minHeight: 90,
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              {competency.title}
                              {competency?.prerequisites?.length > 0 && (
                                <Icon
                                  onMouseEnter={() => {
                                    setHover(competency.id);
                                  }}
                                  onMouseLeave={() => {
                                    setHover(null);
                                  }}
                                  title="Prerequistes exist"
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevent parent click
                                    setSelectedCompetency(competency);
                                    setChainModalOpen(true);
                                  }}
                                  sx={{
                                    width:
                                      onHover === competency.id
                                        ? "50px"
                                        : "none",
                                    color: "#007f00",
                                    background: "white",
                                    padding: "4px",
                                    borderBottomLeftRadius: "10px",
                                    borderTopLeftRadius: "10px",
                                    // fontSize: "22px",
                                    position: "absolute",
                                    zIndex: 100,
                                    top: competency?.required ? 45 : 7,
                                    right: 0,
                                    boxShadow: "0 4px 4px #0000007a",
                                    border:
                                      onHover === competency.id
                                        ? "1px solid rgb(0, 163, 0)"
                                        : "1px solid transparent",
                                  }}
                                >
                                  add_task
                                </Icon>
                              )}
                              {competency?.required && (
                                <Icon
                                  title="Required for graduation"
                                  sx={{
                                    color: "#ff6600",
                                    background: "white",
                                    padding: "4px",
                                    borderBottomLeftRadius: "10px",
                                    borderTopLeftRadius: "10px",
                                    // fontSize: "22px",
                                    position: "absolute",
                                    zIndex: 100,
                                    top: 7,
                                    right: 0,
                                    boxShadow: "0 4px 4px #0000007a",
                                  }}
                                >
                                  star
                                </Icon>
                              )}
                            </StyledText>
                          </CustomAssessmentBlock>
                        </FlexGrow>
                        <FlexGrow style={{ width: "100%" }}>
                          <div
                            style={{
                              textAlign: "center",
                              background:
                                "linear-gradient(270deg,#3a84ee 0%,#1a5edf 100%)",
                              paddingTop: "8px",
                              borderBottomRightRadius: "12px",
                              borderBottomLeftRadius: "12px",
                            }}
                          >
                            <StyledText
                              style={{
                                lineHeight: "35px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                fontSize: "0.8rem",
                              }}
                            >
                              Assessment Only
                            </StyledText>
                          </div>
                        </FlexGrow>
                      </FlexBox>
                    </>
                  ) : (
                    <CustomBlock
                      style={{
                        opacity: competency?.included ? "0.5" : "1",
                      }}
                      backgroundColor={competency?.graphics?.iconbg}
                      onClick={() => {
                        if (!competency?.included) {
                          setSelectedCompetency(competency);
                          setIsModalOpen(true);
                        } else {
                          setIsErrorOpen(true);
                          setIsErrorOpen(true);
                        }
                      }}
                    >
                      <div style={{ padding: "5px 0px", fontWeight: "bold" }}>
                        {competency?.competency_code}
                      </div>
                      <StyledImg
                        src={
                          competency?.graphics?.imgurl
                            ? process.env.REACT_APP_IMG_URL +
                            competency?.graphics?.imgurl
                            : defaultImg
                        }
                        alt=""
                      />
                      <Icon
                        sx={{
                          color: "white",
                          padding: "6px",
                          background: competency?.graphics?.iconbg,
                          borderRadius: "100px",
                          fontSize: "27px",
                          position: "absolute",
                          left: "50%",
                          bottom: "105px",
                          transform: "translateX(-50%)",
                          boxShadow: competency?.graphics?.iconshadow,
                        }}
                      >
                        {competency?.graphics?.icon}
                      </Icon>
                      <StyledText
                        fontWeight="700"
                        style={{
                          minHeight: 90,
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {competency?.title}
                        {competency?.prerequisites?.length > 0 && (
                          <Icon
                            onMouseEnter={() => {
                              setHover(competency?.id);
                            }}
                            onMouseLeave={() => {
                              setHover(null);
                            }}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent click
                              setSelectedCompetency(competency);
                              setChainModalOpen(true);
                            }}
                            title="Prerequistes exist"
                            sx={{
                              width:
                                onHover === competency?.id ? "50px" : "none",
                              color: "#007f00",
                              background: "white",
                              padding: "4px",
                              borderBottomLeftRadius: "10px",
                              borderTopLeftRadius: "10px",
                              // fontSize: "22px",
                              position: "absolute",
                              zIndex: 100,
                              top: competency?.required ? 45 : 7,
                              right: 0,
                              boxShadow: "0 4px 4px #0000007a",
                              border:
                                onHover === competency?.id
                                  ? "1px solid rgb(0, 163, 0)"
                                  : "1px solid transparent",
                            }}
                          >
                            add_task
                          </Icon>
                        )}
                        {competency?.required && (
                          <Icon
                            title="Required for graduation"
                            sx={{
                              color: "#ff6600",
                              background: "white",
                              padding: "4px",
                              borderBottomLeftRadius: "10px",
                              borderTopLeftRadius: "10px",
                              // fontSize: "22px",
                              position: "absolute",
                              zIndex: 100,
                              top: 7,
                              right: 0,
                              boxShadow: "0 4px 4px #0000007a",
                            }}
                          >
                            star
                          </Icon>
                        )}
                      </StyledText>
                    </CustomBlock>
                  )}
                </>
              ))
            ) : (
              <FlexGrow style={{ textAlign: "center" }}>
                <StyledText
                  color="red"
                  fontWeight="700"
                  textSize={TextSize.default}
                >
                  {props.warningMessage
                    ? props.warningMessage
                    : "No competency for the selected semester and domain"}
                </StyledText>
              </FlexGrow>
            )}
          </FlexBox>
        </>
      )}
    </>
  );
}
export default CompetenciesList;
